<template>
  <div id="app">
    <div class="header">
      <Header />
    </div>
    <router-view :key='key' />
    <div class="footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import Header from './components/header/index.vue'
import Footer from './components/footer/index.vue'
export default {
  name: 'App',
  components: {
    Header,Footer
  },
  computed: {
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + new Date()
        : this.$route + new Date();
    }
  }
}
</script>

<style>
.header{
  /* height: 100px; */
}
</style>



// WEBPACK FOOTER //
// src/App.vue